import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.143 3.486a1 1 0 0 1 1.714 0l9 15a1 1 0 0 1 -.857 1.514h-18a1 1 0 0 1 -.857 -1.514z","key":"svg-0"}]]

const IconBrandVercelFilled = createReactComponent('filled', 'brand-vercel-filled', 'BrandVercelFilled', __iconNode);

export default IconBrandVercelFilled;